var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// node_modules/@amzn/awsconsole-web-utils/dist/internal/cookieUtils.js
var parseCookiesString = (cookieString) => {
  const allCookies = document.cookie.length > 0 ? cookieString.split(";") : [];
  const len = allCookies.length;
  const parsedCookiesMap = {};
  for (let i = 0; i < len; i++) {
    const cookieParts = allCookies[i].split("=");
    const cookieName = cookieParts[0].trim();
    const cookieValue = cookieParts[1];
    parsedCookiesMap[cookieName] = { raw: cookieValue };
  }
  return {
    getCookie: (cookieName) => {
      const entry = parsedCookiesMap[cookieName];
      if (!entry) {
        return null;
      }
      let unescapedValue = entry.unescaped;
      if (unescapedValue === void 0) {
        const rawValue = entry.raw;
        unescapedValue = entry.unescaped = unescape(rawValue.trim());
      }
      return unescapedValue;
    }
  };
};
var getCookie = (cookieName) => {
  const cookiesString = document.cookie;
  const parsedCookies = parseCookiesString(cookiesString);
  return parsedCookies.getCookie(cookieName);
};
var cachedValues = {};
var getCookieCached = (cookieName) => {
  let cachedValue = cachedValues[cookieName];
  if (cachedValue === void 0) {
    cachedValue = cachedValues[cookieName] = getCookie(cookieName) || null;
  }
  return cachedValue;
};

// node_modules/@amzn/awsconsole-web-utils/dist/internal/metaTagParser.js
function getMetaTagContent(metaTagName) {
  var _a;
  const selector = `meta[name='${metaTagName}']`;
  let element = document.querySelector(selector);
  if (!element) {
    element = (_a = window.top) == null ? void 0 : _a.document.querySelector(selector);
  }
  return element == null ? void 0 : element.content;
}
function parseMetaTag(metaTagName) {
  const content = getMetaTagContent(metaTagName);
  if (content) {
    return JSON.parse(content);
  } else {
    throw new Error(`failed to parse meta tag ${metaTagName}`);
  }
}

// node_modules/@amzn/awsconsole-web-utils/dist/sessionDataProvider/sessionDataParser.js
var SESSION_DATA_NAME_ATTRIBUTE = "awsc-session-data";
var MEZZ_REGION_NAME_ATTRIBUTE = "awsc-mezz-region";
var _SessionDataParser = class _SessionDataParser {
  constructor() {
    __publicField(this, "sessionDataCache");
    this.sessionDataCache = this.parseSessionDataMetaTag();
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataParserInstance) {
      this.sessionDataParserInstance = new _SessionDataParser();
    }
    return this.sessionDataParserInstance;
  }
  getSessionData() {
    if (this.sessionDataCache) {
      return this.sessionDataCache;
    }
    return this.parseSessionDataMetaTag();
  }
  parseSessionDataMetaTag() {
    let sessionData;
    try {
      sessionData = parseMetaTag(SESSION_DATA_NAME_ATTRIBUTE);
      sessionData.infrastructureRegion || (sessionData.infrastructureRegion = this.getInfrastructureRegionFromMezzanineMetaTag());
    } catch (error) {
      console.warn("Unable to parse session meta tag. Falling back to legacy", error);
      sessionData = this.parseSessionDataLegacy();
    }
    this.validateSessionData(sessionData);
    return sessionData;
  }
  validateSessionData(data) {
    if (!(data == null ? void 0 : data.sessionARN)) {
      this.throwErrorOnField("session data is missing sessionARN");
    }
    if (!(data == null ? void 0 : data.identityToken)) {
      this.throwErrorOnField("session data is missing identityToken");
    }
    if (!(data == null ? void 0 : data.accountId)) {
      this.throwErrorOnField("session data is missing accountId");
    }
    if (!(data == null ? void 0 : data.infrastructureRegion)) {
      this.throwErrorOnField("session data is missing infrastructureRegion");
    }
  }
  throwErrorOnField(fieldName) {
    const message = `session data is missing ${fieldName}`;
    if (false) {
      console.warn(message);
    } else {
      throw new Error(message);
    }
  }
  getSessionDataFromUserInfoCookie() {
    const cookieValue = getCookieCached("aws-userInfo");
    const cookieValueUserinfoSigned = getCookieCached("aws-userInfo-signed");
    const ARN_REGEX = /arn:([^:]*):([^:]*):([^:]*):([^:]*):([^:]*)/;
    if (cookieValue && cookieValueUserinfoSigned) {
      const { arn, alias, username } = JSON.parse(cookieValue);
      const match = ARN_REGEX.exec(arn);
      return {
        accountId: match ? match[4] : "",
        sessionARN: arn,
        accountAlias: alias,
        displayName: username,
        identityToken: cookieValueUserinfoSigned
      };
    }
    throw new Error("No userinfo or userinfo-signed cookie found!");
  }
  getInfrastructureRegionFromMezzanineMetaTag() {
    return getMetaTagContent(MEZZ_REGION_NAME_ATTRIBUTE);
  }
  parseSessionDataLegacy() {
    try {
      return {
        ...this.getSessionDataFromUserInfoCookie(),
        infrastructureRegion: this.getInfrastructureRegionFromMezzanineMetaTag()
      };
    } catch (error) {
      console.warn("Unable to parse the data using legacy methods");
      throw error;
    }
  }
};
__publicField(_SessionDataParser, "sessionDataParserInstance");
var SessionDataParser = _SessionDataParser;

// node_modules/@amzn/awsconsole-web-utils/dist/sessionDataProvider/index.js
var _SessionDataProvider = class _SessionDataProvider {
  constructor(instance) {
    __publicField(this, "dataParser");
    this.dataParser = instance;
  }
  /*
   * Return SessionDataProvider instance for singleton class.
   */
  static getInstance() {
    if (!this.sessionDataProviderInstance) {
      this.sessionDataProviderInstance = new _SessionDataProvider(SessionDataParser.getInstance());
    }
    return this.sessionDataProviderInstance;
  }
  /**
   * @returns sessionARN: Promise<string>
   */
  async getSessionARN() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionARN"];
  }
  /**
   * @returns accountId: Promise<string>
   */
  async getAccountId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountId"];
  }
  /**
   * @returns identityToken: Promise<string>
   */
  async getIdentityToken() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["identityToken"];
  }
  /**
   * @returns sessionId: Promise<string>
   */
  async getSessionId() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionId"];
  }
  /**
   * This method provides the region the page is served from.
   *
   * @returns region: Promise<string>
   */
  async getInfrastructureRegion() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["infrastructureRegion"];
  }
  /**
   * This method provides the VPC if it exists.
   *
   * @returns vpc: Promise<VPC | undefined>
   */
  async getVpc() {
    const sessionData = this.dataParser.getSessionData();
    let result;
    if (sessionData) {
      result = sessionData["vpc"];
    }
    return result;
  }
  /**
   * This method provides the accountAlias if it exists.
   *
   * @returns accountAlias: Promise<string | undefined>
   */
  async getAccountAlias() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["accountAlias"];
  }
  /**
   * This method provides the displayName if it exists.
   *
   * @returns displayName: Promise<string | undefined>
   */
  async getDisplayName() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["displayName"];
  }
  /**
   * This method provides the sessionDifferentiator if it exists.
   *
   * @returns sessionDifferentiator: Promise<string | undefined>
   */
  async getSessionDifferentiator() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData["sessionDifferentiator"];
  }
  /**
   * This method provides an object with current session information and some of the fields are optional
   * and may not be always present. If you only care about getting individual properties, use the respective function such as
   * getAccountId
   * @returns SessionData
   */
  async getSessionData() {
    const sessionData = this.dataParser.getSessionData();
    return sessionData;
  }
};
__publicField(_SessionDataProvider, "sessionDataProviderInstance");
var SessionDataProvider = _SessionDataProvider;

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/csp.js
var ExternalCspAssetName;
(function(ExternalCspAssetName2) {
  ExternalCspAssetName2["WebWorker"] = "worker.js";
  ExternalCspAssetName2["IFrame"] = "iFrame.html";
})(ExternalCspAssetName || (ExternalCspAssetName = {}));

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/metadata.js
var PackageMetadataRequestQueryParams;
(function(PackageMetadataRequestQueryParams2) {
  PackageMetadataRequestQueryParams2["PackageName"] = "packageName";
  PackageMetadataRequestQueryParams2["MajorVersion"] = "majorVersion";
  PackageMetadataRequestQueryParams2["AliasName"] = "aliasName";
  PackageMetadataRequestQueryParams2["AccountId"] = "accountId";
  PackageMetadataRequestQueryParams2["Region"] = "region";
  PackageMetadataRequestQueryParams2["CacheInvalidator"] = "cacheInvalidator";
})(PackageMetadataRequestQueryParams || (PackageMetadataRequestQueryParams = {}));

// node_modules/@amzn/aws-console-lotus-data-plane-interface/dist/isolatedIFrame.js
var IsolatedIFrameRequestQueryParams;
(function(IsolatedIFrameRequestQueryParams2) {
  IsolatedIFrameRequestQueryParams2["PackageName"] = "packageName";
  IsolatedIFrameRequestQueryParams2["MajorVersion"] = "majorVersion";
  IsolatedIFrameRequestQueryParams2["AliasName"] = "aliasName";
  IsolatedIFrameRequestQueryParams2["AccountId"] = "accountId";
  IsolatedIFrameRequestQueryParams2["SessionDifferentiator"] = "sessionDifferentiator";
  IsolatedIFrameRequestQueryParams2["ConsoleRegion"] = "consoleRegion";
  IsolatedIFrameRequestQueryParams2["UnifiedConsoleLoaderPackageName"] = "unifiedConsoleLoaderPackageName";
  IsolatedIFrameRequestQueryParams2["ParentOrigin"] = "parentOrigin";
  IsolatedIFrameRequestQueryParams2["LayoutBackgroundColorToken"] = "layoutBackgroundColorToken";
  IsolatedIFrameRequestQueryParams2["AwsUiVisualRefresh"] = "awsuiVisualRefresh";
  IsolatedIFrameRequestQueryParams2["Modal"] = "modal";
})(IsolatedIFrameRequestQueryParams || (IsolatedIFrameRequestQueryParams = {}));

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/lib/types.js
var LotusPanoramaDimensionName;
(function(LotusPanoramaDimensionName2) {
  LotusPanoramaDimensionName2["PackageMajorVersion"] = "packageMajorVersion";
  LotusPanoramaDimensionName2["CspHandlerType"] = "cspHandlerType";
  LotusPanoramaDimensionName2["Stage"] = "stage";
  LotusPanoramaDimensionName2["Region"] = "region";
  LotusPanoramaDimensionName2["Service"] = "service";
})(LotusPanoramaDimensionName || (LotusPanoramaDimensionName = {}));

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/lib/Logger.js
var getPanoramaService = () => {
  var _a;
  if (!window.panorama) {
    try {
      return (_a = window.top) == null ? void 0 : _a.panorama;
    } catch (e) {
      return void 0;
    }
  }
  return window.panorama;
};
var getClogService = () => {
  var _a;
  let AWSC = window.AWSC;
  if (!(AWSC == null ? void 0 : AWSC.Clog)) {
    try {
      AWSC = (_a = window.top) == null ? void 0 : _a.AWSC;
    } catch (e) {
      return void 0;
    }
  }
  return AWSC == null ? void 0 : AWSC.Clog;
};
var Logger = class {
  constructor(props) {
    __publicField(this, "props");
    __publicField(this, "METRIC_PREFIX", "lotus");
    __publicField(this, "panoramaStartTime");
    /**
     * Get Elapsed Time
     * @returns {number}
     */
    __publicField(this, "getElapsedTime", () => performance.now() - this.panoramaStartTime);
    /**
     * Generate Panorama custom dimension
     * @param {string} packageName
     * @param {string} majorVersion
     * @returns {PanoramaCustomDimension}
     */
    __publicField(this, "createPackageMajorVersionCustomDimension", (packageName, majorVersion) => {
      return {
        dimensionName: LotusPanoramaDimensionName.PackageMajorVersion,
        dimensionValue: `${packageName}@${majorVersion}`
      };
    });
    /**
     * Log Panorama operational event
     * @param {PanoramaOperationalDataObject} params
     * @param {string} packageName
     */
    __publicField(this, "logPanoramaOperationalEvent", (params, packageName, props) => {
      const panorama = getPanoramaService();
      const defaultCustomProperties = [{ propertyName: "awtSource", propertyValue: "lotus" }];
      const finalCustomProperties = (props == null ? void 0 : props.customProperties) ? props.customProperties.concat(defaultCustomProperties) : defaultCustomProperties;
      if (typeof panorama === "function") {
        panorama("trackWidgetOpsEvents", params, [packageName], finalCustomProperties);
      } else {
        console.warn("Lotus: Panorama is not available.");
      }
    });
    /**
     * Log Clog custom event
     * @param ClogMetric
     * @param packageName
     */
    __publicField(this, "logClogCustomEvent", (ClogMetric, packageName) => {
      const clog = getClogService();
      if (typeof (clog == null ? void 0 : clog.log) === "function") {
        const MAX_CLOG_METRIC_LENGTH = 32;
        clog.log({ ...ClogMetric, key: ClogMetric.key.slice(0, MAX_CLOG_METRIC_LENGTH) });
        if (ClogMetric.key.length >= MAX_CLOG_METRIC_LENGTH - 1) {
          return;
        }
        if (!packageName) {
          return;
        }
        const shortenedPackageName = packageName.replace(/^@amzn\//gi, "").replace(/aws/g, "").replace(/[^\w_]/gi, "").replace(/[aeiou]/gi, "");
        if (shortenedPackageName.length > 0) {
          clog.log({
            ...ClogMetric,
            key: `${ClogMetric.key}_${shortenedPackageName}`.slice(0, 32)
          });
        }
      } else {
        console.warn("Lotus: AWSC.Clog is not available.");
      }
    });
    this.props = props;
  }
  /**
   * Initializes panoramaStartTime which is used in getElapsedTime() to get elapsed time
   * @returns {number}
   */
  startTimer() {
    this.panoramaStartTime = performance.now();
    return this.panoramaStartTime;
  }
  /**
   * Create Success Panorama Metric
   * @returns {PanoramaMetric}
   */
  createSuccessPanoramaMetric() {
    return {
      metricName: `${this.METRIC_PREFIX}${this.props.metricNameInfix}Error`,
      metricValue: 0
    };
  }
  /**
   * Create Success CLOG Metric
   * @returns {ClogMetric}
   */
  createSuccessClogMetric() {
    return {
      key: `${this.METRIC_PREFIX}${this.props.clogKeyInfix}E`,
      value: 0
    };
  }
  /**
   * Create Error Panorama Metric
   * @param errMessage
   * @returns {PanoramaMetric}
   */
  createErrorPanoramaMetric(errMessage) {
    return {
      metricName: `${this.METRIC_PREFIX}${this.props.metricNameInfix}Error`,
      metricValue: 1,
      // TODO: revisit metricDetails format to support various logging level and apigw request id
      metricDetails: errMessage
    };
  }
  /**
   * Create Error CLOG Metric
   * @param errMessage
   * @returns {ClogMetric}
   */
  createErrorClogMetric(errMessage) {
    return {
      key: `${this.METRIC_PREFIX}${this.props.clogKeyInfix}E`,
      value: 1,
      detail: errMessage
    };
  }
  /**
   * Create Status Code Panorama Metric
   * @param statusCode
   * @returns {PanoramaMetric}
   */
  createStatusCodePanoramaMetric(statusCode) {
    return {
      metricName: `${this.METRIC_PREFIX}${this.props.metricNameInfix}${statusCode.toString()}`,
      metricValue: 1
    };
  }
  /**
   * Create Status Code CLOG Metric
   * @param statusCode
   * @returns {ClogMetric}
   */
  createStatusCodeClogMetric(statusCode) {
    return {
      key: `${this.METRIC_PREFIX}${this.props.clogKeyInfix}${statusCode.toString()}`,
      value: 1
    };
  }
  /**
   * Create Status Code Class Panorama Metric
   * @param statusCodeClass
   * @param metricValue
   * @returns {PanoramaMetric}
   */
  createStatusCodeClassPanoramaMetric(statusCodeClass, metricValue) {
    return {
      metricName: `${this.METRIC_PREFIX}${this.props.metricNameInfix}${statusCodeClass}xx`,
      metricValue
    };
  }
  /**
   * Create Status Code Class CLOG Metric
   * @param statusCodeClass
   * @param value
   * @returns {ClogMetric}
   */
  createStatusCodeClassClogMetric(statusCodeClass, value) {
    return {
      key: `${this.METRIC_PREFIX}${this.props.clogKeyInfix}${statusCodeClass}xx`,
      value
    };
  }
  /**
   * Create Latency Panorama Metric
   * @param elapsedTime
   * @returns
   */
  createLatencyPanoramaMetric(elapsedTime) {
    return {
      metricName: `${this.METRIC_PREFIX}${this.props.metricNameInfix}Latency`,
      metricValue: elapsedTime,
      metricUnit: "Milliseconds"
    };
  }
  /**
   * Create Latency CLOG Metric
   * @param elapsedTime
   * @returns {ClogMetric}
   */
  createLatencyClogMetric(elapsedTime) {
    return {
      key: `${this.METRIC_PREFIX}${this.props.clogKeyInfix}L`,
      value: elapsedTime,
      unit: "ms"
    };
  }
};

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/lib/regionPartitionMap.js
var regionPartitionMap = {
  "us-iso-west-1": "aws-iso",
  "cn-north-1": "aws-cn",
  "us-iso-east-1": "aws-iso",
  "us-isob-west-1": "aws-iso-b",
  "us-isob-east-1": "aws-iso-b",
  "us-gov-east-1": "aws-us-gov",
  "us-gov-west-1": "aws-us-gov",
  "cn-northwest-1": "aws-cn"
};

// node_modules/@amzn/aws-console-lotus-web-client-common/dist/lib/consolePartitionInfo.js
var Partition;
(function(Partition2) {
  Partition2["AWS"] = "aws";
  Partition2["AWSCN"] = "aws-cn";
  Partition2["AWSUSGOV"] = "aws-us-gov";
  Partition2["AWSISO"] = "aws-iso";
  Partition2["AWSISOB"] = "aws-iso-b";
})(Partition || (Partition = {}));
var PARTITION_INFO = {
  [Partition.AWS]: {
    rootDomain: "amazon.com",
    defaultRegion: "us-east-1",
    regionlessSubDomain: "console.aws",
    globalSubDomain: "global.console.aws"
  },
  [Partition.AWSCN]: {
    rootDomain: "amazonaws.cn",
    defaultRegion: "cn-north-1",
    regionlessSubDomain: "console"
  },
  [Partition.AWSUSGOV]: {
    rootDomain: "amazonaws-us-gov.com",
    defaultRegion: "us-gov-west-1",
    regionlessSubDomain: "console"
  },
  [Partition.AWSISO]: {
    rootDomain: "c2shome.ic.gov",
    defaultRegion: "us-iso-east-1",
    regionlessSubDomain: "console"
  },
  [Partition.AWSISOB]: {
    rootDomain: "sc2shome.sgov.gov",
    defaultRegion: "us-isob-east-1",
    regionlessSubDomain: "console"
  }
};
var AWSC_MEZZ_REGION_ID = "awsc-mezz-region";
function getCurrentRegion() {
  const mezzRegionElement = document.getElementById(AWSC_MEZZ_REGION_ID);
  let region = mezzRegionElement == null ? void 0 : mezzRegionElement.getAttribute("content");
  if (!mezzRegionElement) {
    try {
      const topWindowMezzRegionElement = window.top.document.getElementById(AWSC_MEZZ_REGION_ID);
      region = topWindowMezzRegionElement == null ? void 0 : topWindowMezzRegionElement.getAttribute("content");
    } catch (e) {
    }
  }
  if (region) {
    return region;
  }
  console.warn("Lotus: awsc-mezz-region element is not available. Falling back to default region");
  for (const partitionInfo of Object.values(PARTITION_INFO)) {
    if (window.location.host.indexOf(partitionInfo.rootDomain) >= 0) {
      return partitionInfo.defaultRegion;
    }
  }
  return "us-east-1";
}
function getLotusHost(region) {
  const partition = regionPartitionMap[region] || Partition.AWS;
  const partitionInfo = PARTITION_INFO[partition];
  if (partitionInfo.globalSubDomain) {
    return `${PARTITION_INFO[partition].globalSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
  }
  return `${region}.${PARTITION_INFO[partition].regionlessSubDomain}.${PARTITION_INFO[partition].rootDomain}`;
}

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/tangerineBox/errors.js
var TangerineBoxError = class extends Error {
  constructor(message, originalError) {
    super(message);
    __publicField(this, "message");
    __publicField(this, "originalError");
    this.message = message;
    this.originalError = originalError;
    this.name = this.constructor.name;
    if (originalError) {
      this.stack += `
Caused by: ${originalError.stack}`;
    }
  }
};
var MetaTagParsingError = class extends TangerineBoxError {
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/tangerineBox/parseMetaTag.js
function parseMetaTag2(metaTagName) {
  const element = document.querySelector(`meta[name='${metaTagName}']`);
  if (!element) {
    return void 0;
  }
  return element.content;
}
function parseTangerineBoxMetaTag() {
  const element = parseMetaTag2("tb-data");
  if (!element) {
    throw new MetaTagParsingError("TangerineBox meta tag not found");
  }
  try {
    return JSON.parse(element);
  } catch (error) {
    throw new MetaTagParsingError("Unable to parse TangerineBox meta tag contents", error instanceof Error ? error : new Error(String(error)));
  }
}

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/tangerineBox/TangerineBox.js
var metaTagContentCache;
var TangerineBox = class {
  constructor(metaTagContent) {
    if (metaTagContent) {
      metaTagContentCache = metaTagContent;
    }
  }
  /**
   * Returns the base URL for a given asset ID
   *
   * @see https://quip-amazon.com/xBRHARHS2ZZb/Documentation-04-Building-a-web-application#cDO9CAtNqxS
   */
  getCdnUrl(assetId) {
    if (/^(http|https|ws|wss):\/\//.test(assetId)) {
      return assetId;
    }
    return `${this.getMetaTagContent().cdn}${assetId}`;
  }
  /** Returns parsed content of tb-data meta tag */
  getMetaTagContent() {
    if (!metaTagContentCache) {
      metaTagContentCache = parseTangerineBoxMetaTag();
    }
    return metaTagContentCache;
  }
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/types.js
var SigninStage;
(function(SigninStage2) {
  SigninStage2["PROD"] = "prod";
  SigninStage2["PRODISH"] = "prodish";
})(SigninStage || (SigninStage = {}));
var AccessType;
(function(AccessType2) {
  AccessType2["AnyAccount"] = "ANY_ACCOUNT";
  AccessType2["AllowedAccounts"] = "ALLOWED_ACCOUNTS";
})(AccessType || (AccessType = {}));
var LotusMetadataClientError = class extends Error {
  constructor({ name, message, cause, status }) {
    super(message, cause);
    __publicField(this, "status");
    this.status = status;
    this.name = name;
  }
};
var ErrorType;
(function(ErrorType2) {
  ErrorType2["NetworkError"] = "NetworkError";
  ErrorType2["InvalidParametersError"] = "InvalidParametersError";
  ErrorType2["InvalidResponseError"] = "InvalidResponseError";
})(ErrorType || (ErrorType = {}));

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/MetadataLogger.js
var MetadataLogger = class extends Logger {
  constructor() {
    super({ metricNameInfix: "Metadata", clogKeyInfix: "M" });
    this.startTimer();
  }
  /**
   * log multiple metrics from a finished request.
   * @param {string} packageName
   * @param {string} majorVersion
   * @param {number} statusCode
   * @param {number} elapsedTime
   * @param {Error} error - Optional
   */
  logRequest({ packageName, majorVersion, elapsedTime, statusCode, error, responseHeaders }) {
    const panoramaMetricList = [];
    const clogMetricList = [];
    if (error) {
      const errMessage = this.buildLogErrorMessage(error);
      panoramaMetricList.push(this.createErrorPanoramaMetric(errMessage));
      clogMetricList.push(this.createErrorClogMetric(errMessage));
    } else {
      panoramaMetricList.push(this.createSuccessPanoramaMetric());
      clogMetricList.push(this.createSuccessClogMetric());
    }
    if (statusCode) {
      panoramaMetricList.push(this.createLatencyPanoramaMetric(elapsedTime));
      clogMetricList.push(this.createLatencyClogMetric(elapsedTime));
      panoramaMetricList.push(this.createStatusCodePanoramaMetric(statusCode));
      clogMetricList.push(this.createStatusCodeClogMetric(statusCode));
      ["2", "4", "5"].forEach((statusCodeClass) => {
        const isStatusCodeClass = statusCodeClass === statusCode.toString()[0] ? 1 : 0;
        panoramaMetricList.push(this.createStatusCodeClassPanoramaMetric(statusCodeClass, isStatusCodeClass));
        clogMetricList.push(this.createStatusCodeClassClogMetric(statusCodeClass, isStatusCodeClass));
      });
    }
    this.emitPanoramaMetric({
      metricList: panoramaMetricList,
      packageName,
      majorVersion,
      responseHeaders
    });
    clogMetricList.forEach((metric) => this.logClogCustomEvent(metric, packageName));
  }
  /**
   * Emit Panorama metric
   * @param {PanoramaMetric[]} metricList
   * @param {string} packageName
   * @param {string} majorVersion
   */
  emitPanoramaMetric({ metricList, packageName, majorVersion, responseHeaders }) {
    const customProperties = responseHeaders ? [
      {
        propertyName: "apiGatewayRequestId",
        propertyValue: responseHeaders.apiGatewayRequestId
      },
      {
        propertyName: "lotusRegion",
        propertyValue: responseHeaders.lotusRegion
      }
    ] : [];
    this.logPanoramaOperationalEvent({
      metricList,
      customDimensions: this.createCustomDimensions(packageName, majorVersion),
      customAggregations: this.createCustomAggregatons()
    }, packageName, { customProperties });
  }
  createCustomDimensions(packageName, majorVersion) {
    return [this.createPackageMajorVersionCustomDimension(packageName, majorVersion)];
  }
  createCustomAggregatons() {
    return [
      // 1. for aggregating metrics in all environment
      [LotusPanoramaDimensionName.Region],
      // 2. [No need to define here!] for lotus canary metrics
      // It's default aggregated in https://w.amazon.com/bin/view/Augurey/Projects/OpsMetrics/Polaroid_Users_Guide#HDefaultDimensionsandAggregations
      // [LotusPanoramaDimensionName.Region, LotusPanoramaDimensionName.Service],
      // 3. for widget producer to filter their widget
      [LotusPanoramaDimensionName.PackageMajorVersion]
    ];
  }
  buildLogErrorMessage(error) {
    return `${error.name}: ${error.message}`;
  }
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/util.js
var LOTUS_METADATA_PATH = "/lotus/metadata";
var getCookie2 = (cookieName) => {
  const cookie = Object.fromEntries(document.cookie.split(";").map((cookieDefinition) => cookieDefinition.split("=").map((data) => decodeURIComponent(data.trim()))));
  return cookie[cookieName];
};
var isValidMetadataStructure = (response) => {
  var _a, _b, _c;
  return (response == null ? void 0 : response.basePath) && (response == null ? void 0 : response.versionId) && (((_a = response == null ? void 0 : response.metadata) == null ? void 0 : _a.module) || ((_c = (_b = response == null ? void 0 : response.metadata) == null ? void 0 : _b.assets) == null ? void 0 : _c.length)) ? true : false;
};
var getRegionInIsolatedIFrame = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const region = searchParams.get(IsolatedIFrameRequestQueryParams.ConsoleRegion);
  if (!region) {
    return void 0;
  }
  return region;
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/requestHelper.js
var REQUEST_TIMEOUT = 1e4;
var CANARY_REQUEST_TIMEOUT = 5e3;
var MAX_TRIES = 4;
var RETRY_DELAY = 100;
var unretryableStatusCodes = [400, 401, 403, 404, 413, 415];
var APIGW_V1_REQUEST_ID_RESP_HEADER = "X-Amz-Apigw-Id";
var APIGW_V2_REQUEST_ID_RESP_HEADER = "Apigw-Requestid";
var LOTUS_REGION_RESP_HEADER = "x-lotus-region";
var sendHttpGetRequest = async (url, headers, timeout) => {
  const controller = new AbortController();
  setTimeout(() => {
    controller.abort();
  }, timeout);
  const requestInit = {
    method: "GET",
    headers,
    credentials: "omit",
    signal: controller.signal
  };
  try {
    const fetchResponse = await fetch(url, requestInit);
    return {
      status: fetchResponse.status,
      body: await fetchResponse.text(),
      responseHeaders: {
        apiGatewayRequestId: fetchResponse.headers.get(APIGW_V2_REQUEST_ID_RESP_HEADER) || fetchResponse.headers.get(APIGW_V1_REQUEST_ID_RESP_HEADER) || "null",
        lotusRegion: fetchResponse.headers.get(LOTUS_REGION_RESP_HEADER) || "null"
      }
    };
  } catch (error) {
    if (error.name === "AbortError") {
      throw new LotusMetadataClientError({
        name: ErrorType.NetworkError,
        message: "Timed out",
        cause: error
      });
    } else {
      throw new LotusMetadataClientError({
        name: ErrorType.NetworkError,
        message: `Fetch error: ${error.message}`,
        cause: error
      });
    }
  }
};
var delayRetry = async (attemptIndex, delayInMs) => {
  const delay = Math.random() * 2 ** attemptIndex * delayInMs;
  await new Promise((resolve) => setTimeout(resolve, delay));
};
var sendHttpGetRequestWithRetries = async (url, headers, requestConfig) => {
  const isCanary = getCookie2("metrics-req-cat") === "canary";
  const tries = (requestConfig == null ? void 0 : requestConfig.tries) || MAX_TRIES;
  const retryDelay = (requestConfig == null ? void 0 : requestConfig.retryDelay) || RETRY_DELAY;
  const timeout = (requestConfig == null ? void 0 : requestConfig.timeout) || (isCanary ? CANARY_REQUEST_TIMEOUT : REQUEST_TIMEOUT);
  let latestError = new Error("Error");
  let latestResponse;
  for (let attemptIndex = 0; attemptIndex < tries; attemptIndex += 1) {
    try {
      latestResponse = await sendHttpGetRequest(url, headers, timeout);
      if (latestResponse.status === 200) {
        break;
      }
      if (unretryableStatusCodes.includes(latestResponse.status)) {
        break;
      }
    } catch (error) {
      latestError = error;
      if (error.name !== ErrorType.NetworkError) {
        break;
      }
    }
    await delayRetry(attemptIndex, retryDelay);
  }
  if (latestResponse !== void 0) {
    return latestResponse;
  }
  throw latestError;
};

// node_modules/@amzn/aws-console-lotus-metadata-client/dist/packageMetadataClient.js
function parseAndValidateMetadataHttpResponse({ status, body }) {
  let parsedBody;
  try {
    parsedBody = JSON.parse(body);
  } catch (e) {
    throw new LotusMetadataClientError({
      name: ErrorType.InvalidResponseError,
      message: "Response body is not valid JSON",
      cause: e,
      status
    });
  }
  if (status < 200 || status >= 300) {
    const { code, message } = parsedBody;
    throw new LotusMetadataClientError({
      name: code || ErrorType.InvalidResponseError,
      message,
      status
    });
  }
  if (!isValidMetadataStructure(parsedBody)) {
    throw new LotusMetadataClientError({
      name: ErrorType.InvalidResponseError,
      message: "Invalid metadata structure in response body",
      status
    });
  }
  const lotusCDNUrl = new URL(parsedBody.basePath);
  try {
    const tangerinebox = new TangerineBox();
    const tbCDNUrlString = tangerinebox.getCdnUrl("");
    const tbCDNUrl = new URL(tbCDNUrlString);
    lotusCDNUrl.hostname = tbCDNUrl.hostname;
    parsedBody.basePath = lotusCDNUrl.toString();
  } catch (e) {
  }
  return parsedBody;
}
var getPackageMetadata = async ({ packageName, majorVersion, host, aliasName, accessType, consoleRegion, onComplete, cacheInvalidator }) => {
  const startTime = performance.now();
  const onCompleteFunction = onComplete ? onComplete : (metrics) => {
    new MetadataLogger().logRequest(metrics);
  };
  let httpGetResponse;
  try {
    if (!packageName || !majorVersion) {
      throw new LotusMetadataClientError({
        name: ErrorType.InvalidParametersError,
        message: "Missing package name or majorVersion."
      });
    }
    const metaDataProvider = SessionDataProvider.getInstance();
    const accountId = await metaDataProvider.getAccountId();
    const currentRegion = consoleRegion || await metaDataProvider.getInfrastructureRegion() || getRegionInIsolatedIFrame() || getCurrentRegion();
    if (!accountId || !currentRegion) {
      throw new LotusMetadataClientError({
        name: ErrorType.InvalidParametersError,
        message: "Missing accountId or console region."
      });
    }
    let headers = {};
    const searchParams = new URLSearchParams({
      [PackageMetadataRequestQueryParams.PackageName]: packageName,
      [PackageMetadataRequestQueryParams.MajorVersion]: majorVersion,
      [PackageMetadataRequestQueryParams.AccountId]: accountId,
      [PackageMetadataRequestQueryParams.Region]: currentRegion
    });
    if (aliasName) {
      searchParams.append(PackageMetadataRequestQueryParams.AliasName, aliasName);
    }
    if (cacheInvalidator) {
      searchParams.append(PackageMetadataRequestQueryParams.CacheInvalidator, cacheInvalidator);
    }
    const packageMetadataApiUrl = `https://${host || getLotusHost(currentRegion)}${LOTUS_METADATA_PATH}?${searchParams.toString()}`;
    const missingIdentityTokenError = new LotusMetadataClientError({
      name: ErrorType.InvalidParametersError,
      message: "Missing identity token."
    });
    if (accessType === AccessType.AllowedAccounts) {
      const identityToken = await metaDataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
    }
    httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers);
    if (httpGetResponse.status === 403 && accessType !== AccessType.AllowedAccounts) {
      const identityToken = await metaDataProvider.getIdentityToken();
      if (!identityToken) {
        throw missingIdentityTokenError;
      }
      headers = {
        "x-userinfo-signed": identityToken
      };
      httpGetResponse = await sendHttpGetRequestWithRetries(packageMetadataApiUrl, headers);
    }
    const packageMetadataResponse = parseAndValidateMetadataHttpResponse(httpGetResponse);
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      statusCode: 200,
      responseHeaders: httpGetResponse.responseHeaders
    });
    return packageMetadataResponse;
  } catch (error) {
    onCompleteFunction({
      packageName,
      majorVersion,
      elapsedTime: performance.now() - startTime,
      error,
      statusCode: httpGetResponse ? httpGetResponse.status : void 0,
      responseHeaders: httpGetResponse ? httpGetResponse.responseHeaders : void 0
    });
    throw error;
  }
};
export {
  getPackageMetadata
};
